module.exports = __webpack_public_path__ + "static/media/support-thumb-1.488c7b1a.jpg";